import { render, staticRenderFns } from "./orderPageView.vue?vue&type=template&id=f307d3a4&scoped=true&"
import script from "./orderPageView.vue?vue&type=script&lang=js&"
export * from "./orderPageView.vue?vue&type=script&lang=js&"
import style0 from "./orderPageView.vue?vue&type=style&index=0&id=f307d3a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f307d3a4",
  null
  
)

export default component.exports